/**
 * Return a primed function that resolves a single mapped value when "prop" is a
 * scalar value, or a mapped breakpoint value when "prop" is a breakpoints
 * object.
 */
export function mapStyle(prop, map) {
  return function (breakpoint) {
    // prop is a valid object accessor
    if (typeof prop === 'string' || typeof prop === 'number') {
      return map[prop];
    } // prop is an object itself and contains property from breakpoint


    if (prop && Object.prototype.hasOwnProperty.call(prop, breakpoint)) {
      var key = prop[breakpoint];
      return key ? map[key] : undefined;
    }

    return undefined;
  };
}